import React from 'react';

export default function RoyalStaffSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="20.11,7.5 17.89,7.5 17.89,5.28 20.11,5.28" fill="#CB8916" />
      <polygon points="17.89,7.5 17.56,7.33 17.56,5.11 17.89,5.28" fill="#6E4A0C" opacity="0.95" />
      <polygon points="22.22,8.0 17.78,8.0 17.78,5.78 22.22,5.78" fill="#CB8916" />
      <polygon points="17.78,8.0 22.22,8.0 21.22,7.5 16.78,7.5" fill="#6E4A0C" opacity="0.95" />
      <polygon points="17.78,8.0 16.78,7.5 16.78,5.28 17.78,5.78" fill="#6E4A0C" opacity="0.95" />
      <polygon points="20.58,11.49 18.36,11.49 18.99,6.68 21.22,6.68" fill="#CB8916" />
      <polygon points="18.36,11.49 20.58,11.49 19.96,10.34 17.74,10.34" fill="#6E4A0C" opacity="0.95" />
      <polygon points="18.36,11.49 17.74,10.34 18.38,5.52 18.99,6.68" fill="#6E4A0C" opacity="0.95" />
      <polygon points="21.76,6.1 19.56,6.1 19.56,5.01 21.76,5.01" fill="#CB8916" />
      <polygon points="19.56,6.1 21.76,6.1 20.44,5.44 18.24,5.44" fill="#6E4A0C" opacity="0.95" />
      <polygon points="19.56,6.1 18.24,5.44 18.24,4.35 19.56,5.01" fill="#6E4A0C" opacity="0.95" />
      <polygon points="17.33,7.22 24.0,7.22 22.67,6.56 16.0,6.56" fill="#6E4A0C" opacity="0.95" />
      <polygon points="21.28,6.34 19.75,7.69 19.24,3.35 20.77,2.0" fill="#6E4A0C" opacity="0.95" />
      <polygon points="21.42,8.15 19.22,8.15 19.22,5.95 21.42,5.95" fill="#CB8916" />
      <polygon points="19.22,8.15 18.9,7.99 18.9,5.79 19.22,5.95" fill="#6E4A0C" opacity="0.95" />
      <polygon points="22.5,18.09 19.17,18.09 19.17,16.98 22.5,16.98" fill="#CB8916" />
      <polygon points="19.17,18.09 22.5,18.09 21.5,17.59 18.17,17.59" fill="#6E4A0C" opacity="0.95" />
      <polygon points="19.17,18.09 18.17,17.59 18.17,16.48 19.17,16.98" fill="#6E4A0C" opacity="0.95" />
      <polygon points="22.5,20.31 19.17,20.31 19.17,19.2 22.5,19.2" fill="#CB8916" />
      <polygon points="19.17,20.31 22.5,20.31 21.5,19.81 18.17,19.81" fill="#6E4A0C" opacity="0.95" />
      <polygon points="19.17,20.31 18.17,19.81 18.17,18.7 19.17,19.2" fill="#6E4A0C" opacity="0.95" />
      <polygon points="23.14,11.43 20.9,11.43 20.64,9.23 22.89,9.23" fill="#CB8916" />
      <polygon points="20.9,11.43 23.14,11.43 22.52,11.98 20.28,11.98" fill="#6E4A0C" opacity="0.95" />
      <polygon points="20.9,11.43 20.28,11.98 20.02,9.77 20.64,9.23" fill="#6E4A0C" opacity="0.95" />
      <polygon points="21.78,38.0 19.56,38.0 19.56,14.67 21.78,14.67" fill="#CB8916" />
      <polygon points="19.56,38.0 21.78,38.0 21.11,37.67 18.89,37.67" fill="#6E4A0C" opacity="0.95" />
      <polygon points="19.56,38.0 18.89,37.67 18.89,14.34 19.56,14.67" fill="#6E4A0C" opacity="0.95" />
      <polygon points="22.55,12.65 21.44,12.65 21.31,11.56 22.42,11.56" fill="#CB8916" />
      <polygon points="23.52,14.69 21.29,14.69 21.03,12.5 23.26,12.5" fill="#CB8916" />
      <polygon points="21.29,14.69 23.52,14.69 22.9,15.24 20.67,15.24" fill="#6E4A0C" opacity="0.95" />
      <polygon points="21.29,14.69 20.67,15.24 20.41,13.05 21.03,12.5" fill="#6E4A0C" opacity="0.95" />
      <polygon points="22.5,36.97 19.17,36.97 19.17,35.86 22.5,35.86" fill="#CB8916" />
      <polygon points="19.17,36.97 22.5,36.97 21.5,36.47 18.17,36.47" fill="#6E4A0C" opacity="0.95" />
      <polygon points="19.17,36.97 18.17,36.47 18.17,35.36 19.17,35.86" fill="#6E4A0C" opacity="0.95" />
    </svg>
  );
}
